import * as constants from './constants';
import * as actions from './actions';
import reducer from './reducer';
import saga from './saga';
import * as selectors from './selectors';

export default {
    constants,
    actions,
    reducer,
    saga,
    selectors,
};
